var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnedrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3992_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8736 7.81281L14.589 4.24571C13.8173 1.22453 10.7521 -0.596435 7.74272 0.178412C6.38758 0.527319 5.21057 1.37065 4.44141 2.54382C4.49885 2.54241 10.8736 7.81281 10.8736 7.81281Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86377 3.21547L6.86362 3.21611C6.15367 2.77467 5.33489 2.54134 4.49979 2.54248C4.48052 2.54248 4.46154 2.54368 4.44227 2.5439C1.95834 2.57481 -0.0303753 4.62145 0.000351311 7.11519C0.0115098 8.01974 0.293039 8.90008 0.808453 9.64211L6.37474 8.94223L10.6423 5.48764L6.86377 3.21547Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5902 4.2457C14.5081 4.23986 14.4258 4.23677 14.3434 4.23645C13.845 4.23597 13.3518 4.33817 12.8943 4.53673L12.8941 4.53638L10.6426 5.48756L13.1247 8.5657L17.5622 9.64859C18.5198 7.86391 17.855 5.63777 16.0772 4.67636C15.6178 4.42796 15.1108 4.28107 14.5902 4.2457Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.808594 9.64209C1.22267 10.2398 1.77468 10.728 2.41749 11.065C3.06031 11.402 3.77481 11.5778 4.5 11.5774H14.3433C15.0033 11.5776 15.651 11.3984 16.2177 11.0588C16.7844 10.7193 17.249 10.232 17.5621 9.64873L10.6424 5.48755L0.808594 9.64209Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3992_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 11.6471,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedrive);
export default __webpack_public_path__ + "static/media/onedrive.a460f6b836122f2f6780dbcf7427c953.svg";
export { ForwardRef as ReactComponent };